import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Vendor libraries
import VueScrollReveal from 'vue-scroll-reveal';
import VueObserveVisibility from 'vue-observe-visibility';
import 'normalize.css';
import 'intersection-observer';
import './styles/app.scss';

import Section from './components/Section';
import SectionTitle from './components/SectionTitle';
import SectionSubTitle from './components/SectionSubTitle';
import Paragraph from './components/Paragraph';
import ParagraphTitle from './components/ParagraphTitle';
import Flex from './components/Flex';

Vue.component('Section', Section);
Vue.component('SectionTitle', SectionTitle);
Vue.component('SectionSubTitle', SectionSubTitle);
Vue.component('Paragraph', Paragraph);
Vue.component('ParagraphTitle', ParagraphTitle);
Vue.component('Flex', Flex);

Vue.use(VueObserveVisibility);
Vue.use(VueScrollReveal, {
  distance: '80px',
  duration: 800,
  easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
  reset: false,
  viewOffset: { bottom: 200 },
});

Vue.config.productionTip = false;

Vue.prototype.$isScrolling = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
